// @flow

import ApiClient from '../client'

const createFooterResource = (baseUrl: string, api: typeof ApiClient) => ({
  getFooterLabels: async (): Promise<any> => {
    return await api.get({endpoint: `/uilabels`})
  },
  updateFooterLabels: async (body: Array<Object>): Promise<any> => {
    return await api.post({endpoint: `/uilabels`, body: body})
  },
})

export default createFooterResource



// WEBPACK FOOTER //
// ./src/api/resources/createFooterResource.js